import { MimaButton, MimaInput, MimaText, Modal, MimaDropdown } from '../../components';
import { Formik } from 'formik';

const EditFaq = ({
    loading,
    validationSchema,
    onSubmit,
    closeModal,
    data,
    items,

}) => {

    return (
        <Modal closeModal={closeModal}>
            <Formik
                initialValues={{
                    question: items.question ? items.question : "",
                    answer: items.answer ? items.answer : "",
                    faqCategory: items.faqCategory ? items.faqCategory : "",
                }}
                onSubmit={onSubmit}
                validationSchema={validationSchema}
            >
                {({
                    handleBlur,
                    handleChange,
                    handleSubmit,
                    setFieldValue,
                    values,
                    errors,
                    touched,
                }) => (
                    <>
                        <MimaText variant="subtitleBold" mb={4}>Edit FAQ</MimaText>
                        <MimaInput
                            labelTitle="Question"
                            name="question"
                            value={values.question}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.question}
                            touched={touched.question}
                        />
                        <MimaInput
                            labelTitle="Answer"
                            name="answer"
                            value={values.answer}
                            onChange={handleChange}
                            onBlur={handleBlur}
                            error={errors.answer}
                            touched={touched.answer}
                        />
                        <MimaDropdown
                            labelTitle="faqCategory"
                            placeholder="Select"
                            name="faqCategory"
                            value={values.faqCategory}
                            id="faqCategory"
                            onChange={data => {
                                setFieldValue('faqCategory', data.key);
                            }}
                            data={data}
                            error={errors.faqCategory}
                            touched={touched.faqCategory}
                        />
                        <MimaButton
                            title="Update"
                            loading={loading}
                            width={38}
                            mt={2}
                            buttonColor="var(--color-dark-4)"
                            onClick={handleSubmit}
                        />
                    </>
                )}

            </Formik>
        </Modal>
    )
}
export default EditFaq;